module.exports = __webpack_public_path__ + "static/media/twitterIcon.62d0108f.svg";